/** @format */

import React, { useEffect, useState } from 'react';
import GridItem from '../../../../components/Grid/GridItem';
import { PlatformResellerCollectionInterface } from '../../../../interfaces/collections/PlatformResellerCollectionInterface';
import { PlatformResellerHelper } from '../../../../helpers/PlatformResellerHelper';
import { Auth } from '../../../../modules/auth/Auth';
import CustomMultiSelect from '../../../../components/Form/CustomMultiSelect';

interface OnlyPlatformResellerMultiFormProps {
    platformResellerList: PlatformResellerCollectionInterface | null;
    platformResellerId: Array<number>;
    handleChangeMultiple: (event: any) => void;
}

const OnlyPlatformResellerMultiForm = (props: OnlyPlatformResellerMultiFormProps): React.ReactElement => {
    const { platformResellerList } = props;
    const [hasChildren, setHasChildren] = useState<boolean>(false);

    useEffect(() => {
        if (platformResellerList && platformResellerList['hydra:member'].length > 0) {
            if (PlatformResellerHelper.hasChildrenResellers(Auth.getUserPlatformResellerId(), platformResellerList['hydra:member'])) {
                setHasChildren(true);
            }
        }
    }, [platformResellerList]);

    return (
        <GridItem xs={4}>
            <CustomMultiSelect
                callback={props.handleChangeMultiple}
                value={props.platformResellerId}
                name={'platformResellerId'}
                isElementsFromApi={true}
                elements={props.platformResellerList}
                elementItemValue={'id'}
                elementItemName={'mainname'}
                label={'specialized_report:h.select_platform_reseller'}
                showSelectAllButton
            />
        </GridItem>
    );
};

export default OnlyPlatformResellerMultiForm;
